module.exports = __webpack_public_path__ + "media/images/flags/16/Sao-Tome-and-Principe-e437faeda1e1f7eaab12a2ace7e9e7db.png";